import * as React from 'react'
import { BaseIconProps } from '../../types'

function SvgDinersClub({ size = '24', color = '#666', ...props }: BaseIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.38 12.016a4.519 4.519 0 00-2.9-4.213v8.426a4.519 4.519 0 002.9-4.213zm-6.132 4.212V7.803a4.523 4.523 0 00-2.898 4.213 4.521 4.521 0 002.898 4.212zm1.617-11.335a7.123 7.123 0 000 14.244 7.122 7.122 0 000-14.244zm-.018 14.916C6.543 19.83 3 16.342 3 12.097 3 7.458 6.543 4.25 10.847 4.25h2.017C17.118 4.25 21 7.457 21 12.097c0 4.244-3.882 7.712-8.136 7.712h-2.017z"
        fill="#0069AA"
      />
    </svg>
  )
}

export default SvgDinersClub
